/**
 * Watermark is disabled for all plans / exports.
 */
const useWatermark = () => {
  return false;
};

export default useWatermark;
